<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useThemeAssignmentsStore } from "@/stores/themeAssignments";

const emit = defineEmits(["refresh"]);
const uiStore = useUiStore();
const themeAssignmentsStore = useThemeAssignmentsStore();
const companyId = useCompanyStore().companyId;

let id = ref(null);
let name = ref(null);
let status = ref(null);
let isSubmitted = ref(false);
let btnText = ref("Activate");
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);

const onSubmit = () => {
  isSubmitted.value = true;
  let data = {
    company_id: companyId,
    data: {
      assignment_ids: [id.value],
      status: status.value,
    },
  };

  themeAssignmentsStore
    .activateThemeAssignment(data)
    .then(() => {
      resetStoreData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

onBeforeMount(() => {
  if (getModalAction.value == "activate_theme_assignment") {
    id.value = getModalInfo.value.id;
    name.value = getModalInfo.value.name;
    status.value = getModalInfo.value.status == "active" ? 0 : 1;
    btnText.value = getModalInfo.value.status == "active" ? "Deactivate" : "Activate";
  }
});
</script>
<template>
  <DModal v-if="getModalAction === 'activate_theme_assignment'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Activate Theme Assignment </template>
    <template #body>
      <div class="delete-text">
        <span
          >Are you sure you want to <b>"Activate"</b> the theme assignment
          <b>{{ name }}</b> ?</span
        >
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-primary add-button mr-30"

          >
            Cancel
          </button>
          <button
            :disabled="isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            {{ btnText }}
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
